import { render, staticRenderFns } from "./CambiarPassUsuario.vue?vue&type=template&id=4b1e8683&scoped=true"
import script from "./CambiarPassUsuario.vue?vue&type=script&lang=js"
export * from "./CambiarPassUsuario.vue?vue&type=script&lang=js"
import style0 from "./CambiarPassUsuario.vue?vue&type=style&index=0&id=4b1e8683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1e8683",
  null
  
)

export default component.exports